(function() {
	'use strict';

	angular.module('cfiApp').controller('CFIController',
			CFIController);

	CFIController.$inject = [ '$scope', '$window', 'CFIService', '$log', 'AlertService','NgTableParams', 
	                          '$state', '$stateParams', 'authExpiredInterceptor', '$filter', 'PolicyService', 'Upload','entity', '$base64', '$uibModal', 'CFI_CONST', 'FileNetService'];

	function CFIController($scope, $window, CFIService, $log, AlertService, NgTableParams, 
			$state, $stateParams, authExpiredInterceptor, $filter, PolicyService, Upload, entity, $base64, $uibModal, CFI_CONST, FileNetService) {
		var cfiCtr = this;
		var self = $scope;
		var param = $stateParams;
		self.loading = false;
		self.cfiInfo = {};
		self.cfiInfo.isReceivePolicy = '2';
		self.cfiInfo.purposeCancel = '1';
		self.cfiInfo.receiveDateNew = new Date();
		self.policyProposalNumDisable = false;
		self.cfiCancelReasons = [];
		self.banksLas = [];
		self.isDisable = false;
		self.cfiInfo.requestTypeCode = CFI_CONST.REQUEST_TYPE_CODE;
		self.cfiInfo.requestTypeName = CFI_CONST.REQUEST_TYPE_NAME;
		self.cfiInfo.requestSubTypeCode = CFI_CONST.REQUEST_SUB_TYPE_CODE;
		self.cfiInfo.requestSubTypeName = CFI_CONST.REQUEST_SUB_TYPE_NAME;
		CFIService.query({uri:'cfi-cancel-reasons'}, function(data){
			self.cfiCancelReasons = data;
		},function(error) {
			
		});
		CFIService.query({uri:'banks-las'}, function(data){
			self.banksLas = data;
		},function(error) {
			
		});
		self.findByPolicyNum = function() {
    		self.clearMessage();
    		self.loading = true;
    		var policyNum = self.cfiInfo.policyNum;
    		
    		CFIService.get({uri:'find-policy',policyProposalNum:self.cfiInfo.policyNum,type:'POL'}, function(result){
				self.cfiInfo = result; 
				if(result.policyNum != null && result.policyNum != '') {
					self.policyProposalNumDisable = true;
				}
				self.loading = false;
    		}, function(respone){
    			self.loading = false;
    		})
    	}
    	
		self.findByProposalNum = function() {
    		self.clearMessage();
    		self.loading = true;
    		CFIService.get({uri:'find-policy',policyProposalNum:self.cfiInfo.proposalNum,type:'PRO'}, function(result){
				self.cfiInfo = result;
				if(result.policyNum != null && result.policyNum != '') {
					self.policyProposalNumDisable = true;
				}
				self.loading = false;
    		}, function(respone){
    			self.loading = false;
    		})
    	}
		function init(){
			if(entity != null) {
				self.cfiInfo = entity;
				if ($stateParams.taskId != undefined && $stateParams.taskId != '') {
					self.cfiInfo.taskInstanceId = $base64.decode($stateParams.taskId);
    			}
				self.isDisable = true;
			}
		}
		init();
		// Save CFI
		cfiCtr.saveCFICancel = function() {
			self.clearMessage();
			var data = [];
			self.loading=true;
			if (self.cfiInfo.attachment) {
				data['file'] = self.cfiInfo.attachment;
				data['cfiInfoDTO'] = new Blob([ JSON
						.stringify(self.cfiInfo) ], {
					type : "application/json"
				});
			}
			Upload.upload(
			{
				url : GLOBAL_URL
						+ 'api/ga/cfi/do-save-cfi-cancel?access_token='
						+ authExpiredInterceptor.getToken(),
				data : data
			}).then(
			function(resp) {
				self.loading=false;
				self.isDisable = true;
				self.cfiInfo.isWorkflow = 2;
				$log.debug('Success ' + resp.config.data.file.name
						+ 'uploaded. Response: ' + resp.data);
			},
			function(resp) {
				self.loading=false;
			},
			function(evt) {
				var progressPercentage = parseInt(100.0
						* evt.loaded / evt.total);
				$log.debug('progress: ' + progressPercentage + '% '
						+ evt.config.data.file.name);
			});
				
		} 
		//Approval CFI
		cfiCtr.approvalCFICancel = function() {
			self.loading=true;
			self.clearMessage();
			CFIService.post({uri:'do-approval-cfi-cancel'},self.cfiInfo, function(result) {
				self.loading=false;
				self.cfiInfo = result;
			}, function(error){
				var modalInstance = $uibModal
				.open({
					animation : true,
					templateUrl : GLOBAL_URL
					+ 'partial?uri=ga/cfi/cfi-send-ps-dialog',
					controller : 'CFISendPsDialogController',
					controllerAs : 'sendPsDlgCtr',
					size : 'lg',
					resolve : {
						
						stepStr: function(){
							return null;;
						},
						numStep: function(){
							return null;
						}
					}
				});
				modalInstance.result.then(function(result) {
					modalInstance = null;
					if (result == '1') {
						self.loading=false;
						return;
					} else if (result == '0') {
						self.loading=false;
						cfiCtr.sendToPsCFICancel();
					}
					
				}, function() {
					self.loading=false;
				});
				self.loading=false;
			});
				
		} 
		//Send to PS CFI
		cfiCtr.sendToPsCFICancel = function() {
			self.loading=true;
			self.clearMessage();
			CFIService.post({uri:'do-send-ps-cfi-cancel'},self.cfiInfo, function(result) {
				self.cfiInfo = result;
				self.loading=false;
			}, function(error){
				self.loading=false;
			});
				
		} 
		// Release CFI
		cfiCtr.releaseCFICancel = function(){
			self.loading=true;
			self.clearMessage();
			CFIService.post({uri:'do-release-cfi-cancel'},self.cfiInfo, function(result) {
						 if(result){
							 self.loading=false;
							 window.location.href = GLOBAL_URL+'task#/common-task';
						 }
					}, function(error){
    		});
		}
		// cancel transaction
		cfiCtr.cfiCancelReason = function(){
    		cfiCtr.animationsEnabled = true;
			var modalInstance = 
				//show dialog
				$uibModal.open({
					animation : cfiCtr.animationsEnabled,
					templateUrl : GLOBAL_URL+'partial?uri=ga/cfi/cfi-cancel-reason-dialog',
					controller : 'CFICancelReasonDialogController as cancelReasonDlgCtr',
					size : 'lg',
					resolve : {
						cfiInfo: function(){
							return self.cfiInfo;
						}
					}
			});
			modalInstance.result.then(
					function(result) {
						self.cfiInfo = result;
					},
					function(error){
						
					});
		}
		// repeat txn
		cfiCtr.reset = function(){
     		//https://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state#methods_reload
    		self.isDisable = false;
    		self.policyProposalNumDisable = false;
    		self.clearMessage();
     		$state.transitionTo($state.current, {}, { 
   			  reload: true, inherit: false, notify: true
   			});
     	}  
		//print letter cfi
		cfiCtr.printLetterCfi = function() {
			self.loading=true;
			CFIService.download({
				uri : 'print-letter-cfi'
			}, self.cfiInfo,function(result){
				if(result){
					 self.loading=false;
					 self.cfiInfo.transaction.printStatus=1;	
				 }
			}, function(error){
					self.loading=false;	
    		});
		};
		// View chữ ký bên mua bảo hiểm
		cfiCtr.checkSignature = function (policyNum){
			if (policyNum == undefined || policyNum == null) return false;
			FileNetService.query({method:'get-list-poldoc',polNum:policyNum}, function(result){
				if(result.length >0){
					cfiCtr.animationsEnabled = true;
					var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : cfiCtr.animationsEnabled,
						templateUrl : GLOBAL_URL+'partial?uri=ga/signature/signature-dialog',
						controller : 'SignatureDialogController as signatureDlgCtrl',
						size : 'lg',
						resolve : {
							items : function() {
								return result;//tranfer data for dialog
							}
						}
					});
					modalInstance.result.then(
					function(result) {
					},
					function(error){
					});
				}else{
					$scope.addAlert('File chữ ký HD ['+policyNum+'] không tồn tại.Vui lòng kiểm tra lại','warning');
				}
    		},
    		function(error){
    		});
		};
		//  ------------------
		cfiCtr.datePickerOpenStatus = {};
		cfiCtr.datePickerOpenStatus.fromDate = false;
		cfiCtr.datePickerOpenStatus.toDate = false;
		cfiCtr.openCalendar = openCalendar;
        function openCalendar (date) {
        	cfiCtr.datePickerOpenStatus[date] = true;
        }
        cfiCtr.dateOptions = {
				//maxDate : new Date()
		};
        cfiCtr.openFromDate = function() {
        	cfiCtr.popupFromDate.opened = true;
		};

		self.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		self.format = $scope.formats[2];
		self.altInputFormats = [ 'M!/d!/yyyy' ];
		cfiCtr.popupFromDate = {
			opened : false
		};

	}

})();
